export default __webpack_public_path__ + "navigation-examples-embedded-navigation-thumbnail-v1-960-651fa1a54f7a28979aa674ca66e1c6e9.png";